import { Grid } from '@mui/material';
import HeaderUserbox from './Userbox';
import GBLogo from 'src/assets/images/gb-logo.svg';
import { HeaderWrapper } from 'src/components/StyledComponents/Navigation';
import LanguageSelector from 'src/components/LanguageSelector';
import {
  FlexCenterGrid,
  GridContainer,
  Logo
} from 'src/components/StyledComponents/Index';

const Header = () => {
  return (
    <HeaderWrapper>
      <GridContainer justifyContent="space-between">
        <FlexCenterGrid item md={6}>
          <GridContainer justifyContent="flex-start">
            <Grid item>
              <Logo src={GBLogo} />
            </Grid>
          </GridContainer>
        </FlexCenterGrid>
        <Grid item lg={3} md={4}>
          <Grid container justifyContent="flex-end" columnSpacing={1}>
            <FlexCenterGrid item>
              <GridContainer justifyContent="flex-start">
                <Grid item>
                  <LanguageSelector />
                </Grid>
              </GridContainer>
            </FlexCenterGrid>
            <Grid item md={6}>
              <HeaderUserbox />
            </Grid>
          </Grid>
        </Grid>
      </GridContainer>
    </HeaderWrapper>
  );
};

export default Header;
